import React, { useEffect, useState } from 'react';
import {
  Box,
  FormLabel,
  Heading,
  Text as TextComponent,
  SimpleGrid,
  Stack,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Checkbox,
  UnorderedList,
  ListItem,
  ButtonGroup,
  Flex,
} from '@chakra-ui/react';
import { Button } from '@landsvirkjun/react.common';
import { useLocation, useNavigate } from 'react-router-dom';
import { PageHeader } from 'routes/layouts/pageHeader';

import {
  ApproversListResult,
  ApprovesDepartment,
  Department,
  useApproversDepartmentsQuery,
  useApproversListQuery,
  useCreateApproverMutation,
  useUpdateApproverQuery,
} from 'api/services/Admin';

import _ from 'lodash';
import { toast } from 'react-toastify';

export const CreateOrUpdateApprover = (): JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();
  const { employeeData } = location.state || {};
  const queryParams = new URLSearchParams(location.search);
  const mode = queryParams.get('mode') as 'edit' | 'create';
  const [user, setUser] = useState<ApproversListResult>();
  // const [userCopy, setUserCopy] = useState<ApproversListResult>();
  const [selectedDepartment, setSelectedDepartment] =
    useState<ApprovesDepartment>();

  const { mutateAsync: createApprover, isLoading: isCreatingApprover } =
    useCreateApproverMutation();
  const { mutateAsync: updateApprover, isLoading: isUpdatingApprover } =
    useUpdateApproverQuery(user?.id ? user?.id.toString() : '');

  const { refetch: getApproversList } = useApproversListQuery();
  const { data: departmentList } = useApproversDepartmentsQuery();

  useEffect(() => {
    if (employeeData) {
      setSelectedDepartment(
        employeeData?.approvesDepartments.find((item) => item.id.length === 2)
      );
      // setUserCopy(_.cloneDeep(employeeData));
      setUser(employeeData);
    }
  }, [employeeData]);

  // const getSingleDepartment = (row: Row<ApprovesDepartment>): void => {
  //   const department = row.original;
  //   const userDepartments = user?.approvesDepartments;
  //   if (userDepartments) {
  //     const updatedUserDepartments = [...userDepartments];

  //     const exists = updatedUserDepartments.some(
  //       (el) => el.id === department.id
  //     );

  //     if (!exists) {
  //       updatedUserDepartments.push(department);
  //     } else {
  //       const index = updatedUserDepartments.findIndex(
  //         (el) => el.id === department.id
  //       );
  //       updatedUserDepartments.splice(index, 1);
  //     }
  //     setUser({ ...user, approvesDepartments: updatedUserDepartments });
  //   }
  // };

  // const getMultipleDepartments = (row: Row<any>[]): void => {
  //   const departments = row.map((r) => r.original);
  //   const userDepartments = user?.approvesDepartments;

  //   if (departments.length === 0) {
  //     setUser(userCopy);
  //     return;
  //   }

  //   if (userDepartments) {
  //     const updatedUserDepartments = [...userDepartments];

  //     departments.forEach((dep) => {
  //       const exists = updatedUserDepartments.some((el) => el.id === dep.id);

  //       if (!exists) {
  //         updatedUserDepartments.push(dep);
  //       }
  //     });
  //     setUser({ ...user, approvesDepartments: updatedUserDepartments });
  //   }
  // };

  function flattenDepartments(
    data: Department | undefined
  ): ApprovesDepartment[] {
    const result: Department[] = [];

    function flatten(departments: Department[]): void {
      departments.forEach((department) => {
        result.push(department);
        if (department.departments.length > 0) {
          flatten(department.departments);
        }
      });
    }

    data?.departments?.forEach((item) => {
      result.push(item);
      if (item.departments.length > 0) {
        flatten(item.departments);
      }
    });

    const approves: ApprovesDepartment[] = result.map((dep) => {
      return { id: dep.id, name: dep.name };
    });

    return approves;
  }

  const getDepartmentsToSubmit = (): ApprovesDepartment[] => {
    const dep = departmentList?.find(
      (item) => item.id === selectedDepartment?.id
    );

    const selectedDeps = flattenDepartments(dep);

    if (dep) {
      const selectedDep: ApprovesDepartment = {
        id: dep.id,
        name: dep.name,
      };

      selectedDeps.unshift(selectedDep);

      if (dep?.id === 'SF') {
        let sfDeps = departmentList
          ?.map((item): ApprovesDepartment => {
            return { id: item.id, name: item.name };
          })
          .filter((a) => a);
        sfDeps?.unshift(...selectedDeps);

        return sfDeps as ApprovesDepartment[];
      }

      // if (selectedDep) {
      //   setUser({ ...user, approvesDepartments: selectedDeps });
      // }
    }

    return selectedDeps;
  };

  const submitApprover = async (): Promise<any> => {
    if (user) {
      const approvesDepartments = getDepartmentsToSubmit();
      if (!approvesDepartments.length) {
        toast.warning('Ekkert svið hefur verið valið til að samþykkja fyrir');
        return false;
      }

      const body = {
        name: user.name || '',
        employeeId: user.employeeId || '',
        id: user.id ? user.id.toString() : '',
        approvesDepartments,
        active: 'true',
      };
      try {
        if (mode === 'edit') {
          await updateApprover(body);
        } else {
          await createApprover(body);
        }
        getApproversList();
        navigate('/admin/samthykkjendur');
      } catch (e) {
        console.error(e);
      }
    }
  };

  return (
    <>
      <PageHeader
        left={
          <Heading as="h2" size="lg">
            {user?.name}
          </Heading>
        }
      />
      {/* <SimpleGrid columns={{ base: 1, md: 2 }} mt={10} gap={20}> */}
      <Box as="div" maxWidth="800px">
        <FormLabel fontWeight={600} mb={5}>
          Veldu það svið sem {user?.name} samþykkir ferðabeiðnir fyrir
        </FormLabel>

        <Accordion allowMultiple>
          {departmentList &&
            departmentList.map((item) => {
              return (
                <AccordionItem key={item.id}>
                  <h2>
                    <AccordionButton>
                      <Checkbox
                        isChecked={selectedDepartment?.id === item.id}
                        onChange={(): void =>
                          setSelectedDepartment({
                            id: item.id,
                            name: item.name,
                          })
                        }
                      />
                      <Box as="span" flex="1" ml={3} textAlign="left">
                        {item.name} ({item.id})
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4}>
                    <UnorderedList>
                      {item.departments.map((dep) => (
                        <ListItem key={dep.id}>
                          {dep.name} ({dep.id})
                          {dep.departments && (
                            <UnorderedList>
                              {dep.departments.map((subDep) => (
                                <ListItem key={subDep.id}>
                                  {subDep.name} ({subDep.id})
                                </ListItem>
                              ))}
                            </UnorderedList>
                          )}
                        </ListItem>
                      ))}
                    </UnorderedList>
                  </AccordionPanel>
                </AccordionItem>
              );
            })}
        </Accordion>

        <Flex flexDirection={'row'}>
          <ButtonGroup gap={3} mt={10} flex={1} justifyContent={'flex-end'}>
            <Button
              variant="secondary"
              onClick={(): void => navigate('/admin/samthykkjendur')}
            >
              Hætta við
            </Button>
            <Button
              variant="primary"
              isLoading={isUpdatingApprover || isCreatingApprover}
              loadingText="Augnablik..."
              // isDisabled={_.isEqual(user, userCopy)}
              isDisabled={!getDepartmentsToSubmit().length}
              onClick={submitApprover}
            >
              {mode === 'create' ? 'Stofna samþykkjanda' : 'Uppfæra notanda'}
            </Button>
          </ButtonGroup>
        </Flex>
      </Box>
      {/* <Box as="div">
          <FormLabel fontWeight={600}>Upplýsingar um starfsmann</FormLabel>
          <Stack direction="row" mt={10}>
            <TextComponent fontWeight={600} color="gray.400" mb={5} mr={2}>
              Nafn:
            </TextComponent>
            <TextComponent> {user?.name}</TextComponent>
          </Stack>
        </Box> */}
      {/* </SimpleGrid> */}
    </>
  );
};
